import { Button, Container, H1, Loader, Modal, Table } from '@itds/elements/index.js';
import React, { useContext, useEffect, useState } from 'react';

import { ACTION_MESSAGES } from '@carrier/utils/custom_hooks/useNotification';
import { Api } from '@carrier/utils/Api';
import { CarrierContext } from '@carrier/contexts/CarrierContext';
import EditDrawer from './Edit';
import Notification from '@carrier/components/Notification';
import PropTypes from 'prop-types';

const List = () => {
  const [admins, setAdmins] = useState([]);
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  const { notification, setNotification } = useContext(CarrierContext);
  const [modal, setModal] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState(null);

  useEffect(() => {
    loadAdmins();
  }, []);

  const loadAdmins = () => {
    setLoading(true);

    Api.loadAdmins().then(response => {
      setAdmins(response.data);
      setLoading(false);
    });
  };

  const handleSave = () => {
    setAdmin(null);
    loadAdmins();
    setNotification(ACTION_MESSAGES.CARRIERS.ADMIN.SAVE);
  };

  const handleDelete = (obj, e) => {
    e.stopPropagation();
    window.scrollTo(0, 0);
    setModal(true);
    setDeleteInfo(obj);
  };

  const confirmDelete = () => {
    window.scrollTo(0, 0);

    Api.deleteAdmin(deleteInfo.id)
      .then(() => {
        loadAdmins();
        setNotification(ACTION_MESSAGES.CARRIERS.ADMIN.DELETE);
        setModal(null);
        setDeleteInfo(null);
      })
      .catch(() => {
        setModal(null);
        setDeleteInfo(null);
      });
  };

  return loading ? (
    <Loader />
  ) : (
    <Container>
      <Notification {...notification} />
      <EditDrawer
        admin={admin}
        onClose={setAdmin.bind(null, null)}
        onSave={handleSave}
        show={!!admin}
      />

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <H1>Admins</H1>

        <Button
          onClick={setAdmin.bind(null, { name: '', email: '', password: '' })}
          style={{ marginLeft: 'auto', marginBottom: 30 }}
        >
          Add Admin
        </Button>
      </div>

      <Table
        columns={[
          {
            id: 'email',
            is_sortable: true,
            label: 'email'
          },
          {
            id: 'is_locked',
            label: '',
            render: row => {
              return row.is_locked ? <i className='mdi mdi-lock' style={{ fontSize: 20 }} /> : null;
            }
          },
          {
            id: 'actions',
            render: row => {
              return (
                <Button
                  color='RED'
                  inline={true}
                  onClick={handleDelete.bind(null, row)}
                  small={true}
                >
                  Delete
                </Button>
              );
            },
            styles: { textAlign: 'right' }
          }
        ]}
        data={admins}
        defaultSortColumn={{ id: 'email' }}
        onRowClick={setAdmin}
      />
      {modal ? (
        <Modal
          buttons={[
            {
              color: 'RED',
              children: 'Confirm Delete',
              onClick: confirmDelete,
              style: { marginLeft: 'auto' }
            }
          ]}
          contained={true}
          onClose={() => {
            setModal(null);
          }}
          title={`Delete "${deleteInfo.email}"`}
        >
          <div style={{ padding: 40, fontSize: 16, textAlign: 'center', lineHeight: '1.5em' }}>
            Are you sure you want to delete "{deleteInfo.email}"?
          </div>
        </Modal>
      ) : null}
    </Container>
  );
};

List.propTypes = {
  setErrorMessage: PropTypes.func,
  setSuccessMessage: PropTypes.func
};

export default List;
